import {
	Award,
	Dumbbell,
	Flame,
	Footprints,
	Lock,
	type LucideIcon,
	Medal,
	StretchHorizontal,
	Trophy,
} from "lucide-react";
import type { BadgeDefinition } from "../types";

const BADGE_ICONS: Record<string, LucideIcon> = {
	Footprints,
	Flame,
	Trophy,
	Dumbbell,
	StretchHorizontal,
	Medal,
	Award,
};

/**
 * Render the full badge catalog with earned ones lit and unearned ones locked,
 * so there's always a visible "next badge to chase".
 */
export function BadgeGrid({
	catalog,
	earnedKeys,
}: {
	catalog: BadgeDefinition[];
	earnedKeys: Set<string>;
}) {
	return (
		<div className="grid grid-cols-2 gap-2.5 sm:grid-cols-3 lg:grid-cols-4">
			{catalog.map((badge) => {
				const earned = earnedKeys.has(badge.key);
				const Icon = earned ? (BADGE_ICONS[badge.icon] ?? Award) : Lock;
				return (
					<div
						key={badge.key}
						title={badge.description}
						className={`flex flex-col items-center gap-1.5 rounded-xl border p-3 text-center transition-colors ${
							earned ? "border-primary/30 bg-primary/5" : "border-hairline bg-surface-1 opacity-60"
						}`}
					>
						<span
							className={`flex size-9 items-center justify-center rounded-full ${
								earned ? "bg-primary/15 text-primary" : "bg-surface-3 text-ink-subtle"
							}`}
						>
							<Icon className="h-4.5 w-4.5" />
						</span>
						<span className="text-body-sm font-medium leading-tight">{badge.name}</span>
						<span className="caption leading-tight text-ink-subtle">{badge.description}</span>
					</div>
				);
			})}
		</div>
	);
}
